import { toast } from 'react-toastify';
import firebase from '../firebase';
import { customAlert } from './alertActions';
import { GET_CUSTOMER_SUPPORT } from './types';

export const setFeedbackLoading = val => {
	return async dispatch => {
		dispatch({
			type: 'CUSTOMER_SUPPORT_LOADING',
			payload: val,
		});
	};
};
export const getMemoirs = () => {
	return dispatch => {
		firebase
			.firestore()
			.collection('customer_supports')
			.onSnapshot(query => {
				var tempCustomerSupports = [];
				query.forEach(doc => {
					tempCustomerSupports.push({ id: doc.id, ...doc.data() });
				});
				dispatch({
					type: GET_CUSTOMER_SUPPORT,
					memoirs: tempCustomerSupports,
				});
			});
	};
};
export const createCustomerSupport = obj => async dispatch => {
	dispatch(setFeedbackLoading(true));
	firebase
		.firestore()
		.collection('customer_supports')
		.add({
			...obj,
			created_at: firebase.firestore.Timestamp.now(),
		})
		.then(res => {
			dispatch(customAlert(true, 'Your response recorded Successfully'));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			// toast.success("Your response recorded Successfully")
			dispatch(setFeedbackLoading(false));
			return;
		})
		.catch(err => {
			dispatch(customAlert(true, err.message));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			// toast.warning(err.message)
			dispatch(setFeedbackLoading(false));
		});
};
